const regularVehicleData = [
    { name: 'Select Vehicle', disabled: true}, // Placeholder entry
    { name: 'Acura', disabled: false }, // 1
    { name: 'Alfa Romeo', disabled: false }, // 2
    { name: 'Audi', disabled: false }, // 3
    { name: 'BMW', disabled: false }, // 4
    { name: 'Buick', disabled: false }, // 5
    { name: 'Cadillac', disabled: false }, // 6
    { name: 'Chevrolet', disabled: false }, // 7
    { name: 'Chrysler', disabled: false }, // 8
    { name: 'Dodge', disabled: false }, // 9
    { name: 'Fiat', disabled: false }, // 10
    { name: 'Ford', disabled: false }, // 11
    { name: 'Genesis', disabled: false }, // 12
    { name: 'GMC', disabled: false }, // 13
    { name: 'Honda', disabled: false }, // 14
    { name: 'Hyundai', disabled: false }, // 15 
    { name: 'Infiniti', disabled: false }, // 16
    { name: 'Jaguar', disabled: false }, // 17
    { name: 'Jeep', disabled: false }, // 18
    { name: 'Kia', disabled: false }, // 19 
    { name: 'Land Rover', disabled: false },  // 20
    { name: 'Lexus', disabled: false }, // 21
    { name: 'Lincoln', disabled: false },   // 22
    { name: 'Mazda', disabled: false }, // 23 
    { name: 'Mercedes-Benz', disabled: false }, // 24
    { name: 'Mini', disabled: false }, // 25
    { name: 'Mitsubishi', disabled : false }, // 26
    { name: 'Nissan', disabled: false }, // 27
    { name: 'Pagani', disabled: false }, // 28
    { name: 'Porsche', disabled: false }, // 29
    { name: 'RAM', disabled: false }, // 30
    { name: 'Subaru', disabled: false }, // 31
    { name: 'Tesla', disabled: false },     // 32
    { name: 'Toyota', disabled: false }, // 33
    { name: 'Volkswagen', disabled: false }, // 34
    { name: 'Volvo', disabled: false } // 35
  ];
    export default regularVehicleData;
